$(function () {

    var closeForm = function ($form) {
        var $modal = $form.parents('.modall');
        window.Modal.closeModal($modal);
    };

    $(document).on('submit', 'form[data-is-ajax=true]', function (event) {
        event.preventDefault();

        var $form = $(this);
        $form.find('.error').remove();

        var $button = $form.find('[type=submit]');

        $button.addClass('button_loading');

        $.post($form.attr('action'), $form.serialize())
        .always(function () {
            $button.removeClass('button_loading');
        })
        .fail(function (data) {
            $(document).trigger('Form::Fail', [data, $form]);

            if ($form.is('[data-render-errors=true]')) {

                var errors = data.responseJSON;

                if (!errors) {
                    return false;
                }

                var globalError = errors.error || (errors.errors ? errors.errors.global : undefined);

                if (globalError) {
                    Toasts.pushToast(globalError, 'fail', undefined, 10000);
                }

                if (errors.errors) {

                    _(errors.errors).each(function(value, key) {
                        $(document).trigger('Form::RenderError', [$form.find('[name*=' + key + ']'), [value]]);
                    });
                }
            }
        })
        .success(function (data) {
            $(document).trigger('Form::Success', [data, $form]);

            if ($form.is('[data-reload-after-success=true]')) {
                document.location.reload();
            }

            if ($form.data('success-text')) {
                Toasts.pushToast($form.data('success-text'), 'success', undefined, 10000);
            }

            closeForm($form);
        });
    });

    $('form[data-submit-on-change=true]')
        .on('CitySelector::Change', function () {
            $(this).submit();
        })
        .find('.form__input')
        .filter(function () {
            return !$(this).is('.city-selector');
        })
        .each(function () {
            var $input = $(this);
            $input.on('change', function () {
                $input.parents('form[data-submit-on-change=true]').submit();
            });
        });

    $(document).on('Form::RenderError', function (event, $input, errors) {
        var $errors = $input.next('.errors-list');

        if ($errors.length < 0) {
            $input.after('<div class="errors-list"></div>');
            $errors = $input.next('.errors-list');
        }

        _(errors).each(function (error) {
            $errors.append('<div class="error">' + error + '</div>');
        });
    });

    $(document).on('Form::Submit', function ($form) {
        $form.submit();
    });

});